const ExpenseWizard = {
    init() {
        const wizardSelector = "[data-expense-wizard], [data-income-wizard]";
        const inWizard = (selector) => `[data-expense-wizard] ${selector}, [data-income-wizard] ${selector}`;

        $(document).on("click", inWizard("[data-wizard-next]"), function () {
            const wizard = $(this).closest(wizardSelector);
            const step = Number(wizard.find("[data-wizard-step].is-active").data("wizard-step"));

            if (ExpenseWizard.validateStep(wizard, step)) {
                ExpenseWizard.showStep(wizard, step + 1);
            }
        });

        $(document).on("click", inWizard("[data-wizard-previous]"), function () {
            const wizard = $(this).closest(wizardSelector);
            const step = Number(wizard.find("[data-wizard-step].is-active").data("wizard-step"));
            ExpenseWizard.showStep(wizard, step - 1);
        });

        $(document).on("click", inWizard("[data-wizard-go]"), function () {
            const wizard = $(this).closest(wizardSelector);
            const currentStep = Number(wizard.find("[data-wizard-step].is-active").data("wizard-step"));
            const targetStep = Number($(this).data("wizard-go"));

            if (targetStep < currentStep || ExpenseWizard.validateThrough(wizard, currentStep, targetStep)) {
                ExpenseWizard.showStep(wizard, targetStep);
            }
        });

        $(document).on("input change", inWizard("[data-wizard-field]"), function () {
            ExpenseWizard.updateSummary($(this).closest(wizardSelector));
        });

        $(document).on("expense:group-selected", "[data-expense-wizard]", function (event, label) {
            const wizard = $(this);
            wizard.find('[data-wizard-summary="group"]').text(label);
            wizard.find('[data-wizard-summary="category"]').text("Nie wybrano");
            ExpenseWizard.showStep(wizard, 4);
        });

        $(document).on("expense:category-selected", "[data-expense-wizard]", function (event, label) {
            const wizard = $(this);
            wizard.find('[data-wizard-summary="category"]').text(label);
            ExpenseWizard.showStep(wizard, 5);
        });

        $(document).on("click", "[data-income-wizard] [data-income-category]", function () {
            const selectedCategory = $(this);
            const wizard = selectedCategory.closest("[data-income-wizard]");

            wizard.find("[data-income-category]").removeClass("is-selected").attr("aria-pressed", "false");
            selectedCategory.addClass("is-selected").attr("aria-pressed", "true");
            wizard.find('[data-wizard-field="category"]').val(selectedCategory.data("income-category")).trigger("change");
            wizard.find('[data-wizard-summary="category"]').text(selectedCategory.data("choice-label"));
            ExpenseWizard.showStep(wizard, 4);
        });
    },

    showStep(wizard, step) {
        const lastStep = wizard.find("[data-wizard-step]").length;
        if (step < 1 || step > lastStep) return;

        wizard.find("[data-wizard-step]").removeClass("is-active").prop("hidden", true);
        wizard.find(`[data-wizard-step="${step}"]`).addClass("is-active").prop("hidden", false);
        wizard.find("[data-wizard-go]").removeClass("is-active is-complete").attr("aria-current", "false");
        wizard.find(`[data-wizard-go="${step}"]`).addClass("is-active").attr("aria-current", "step");
        wizard.find("[data-wizard-go]").filter(function () {
            return Number($(this).data("wizard-go")) < step;
        }).addClass("is-complete");

        if (step === 2) {
            const amountInput = wizard.find('[data-wizard-field="amount"]');
            const amount = amountInput.val();

            if (amount === "" || amount === null) {
                amountInput.trigger("focus");
            }
        }
    },

    validateThrough(wizard, currentStep, targetStep) {
        for (let step = currentStep; step < targetStep; step += 1) {
            if (!this.validateStep(wizard, step)) return false;
        }
        return true;
    },

    validateStep(wizard, step) {
        const stage = wizard.find(`[data-wizard-step="${step}"]`);
        const message = stage.find("[data-wizard-message]");
        let valid = true;

        if (step === 1) valid = Boolean(wizard.find('[data-wizard-field="date"]').val());
        if (step === 2) valid = Number(wizard.find('[data-wizard-field="amount"]').val()) > 0;
        if (step === 3) {
            valid = wizard.is("[data-income-wizard]")
                ? Boolean(wizard.find('[data-wizard-field="category"]').val())
                : wizard.find("[data-group_select].is-selected").length > 0;
        }
        if (step === 4 && wizard.is("[data-expense-wizard]")) {
            valid = Boolean(wizard.find('[data-wizard-field="category"]').val());
        }

        stage.toggleClass("has-step-error", !valid);
        message.prop("hidden", valid).text(valid ? "" : "Uzupełnij ten krok, aby przejść dalej.");
        return valid;
    },

    updateSummary(wizard) {
        const date = wizard.find('[data-wizard-field="date"]').val();
        const amount = wizard.find('[data-wizard-field="amount"]').val();
        wizard.find('[data-wizard-summary="date"]').text(this.formatDate(date));
        wizard.find('[data-wizard-summary="amount"]').text(amount ? `${Number(amount).toFixed(2)} zł` : "--");
    },

    formatDate(date) {
        if (!date) return "--";

        const parts = date.split("-");
        return parts.length === 3 ? `${parts[2]}.${parts[1]}.${parts[0]}` : date;
    },
};

export default ExpenseWizard;
